var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeAttorney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.489 1.367a5.253 5.253 0 015.022 0c.936.509 2.005.722 3.065.61a5.253 5.253 0 014.64 1.921 5.252 5.252 0 002.599 1.736 5.253 5.253 0 013.55 3.551 5.253 5.253 0 001.737 2.599 5.253 5.253 0 011.922 4.64c-.113 1.06.1 2.129.61 3.065a5.253 5.253 0 010 5.022 5.253 5.253 0 00-.61 3.065 5.253 5.253 0 01-1.922 4.64 5.253 5.253 0 00-1.736 2.599 5.253 5.253 0 01-3.551 3.55 5.253 5.253 0 00-2.599 1.737 5.253 5.253 0 01-4.64 1.922 5.253 5.253 0 00-3.065.61 5.253 5.253 0 01-5.022 0 5.253 5.253 0 00-3.065-.61 5.253 5.253 0 01-4.64-1.922 5.253 5.253 0 00-2.599-1.736 5.253 5.253 0 01-3.55-3.551 5.252 5.252 0 00-1.737-2.599 5.253 5.253 0 01-1.922-4.64 5.253 5.253 0 00-.61-3.065 5.253 5.253 0 010-5.022c.51-.936.723-2.005.61-3.065a5.253 5.253 0 011.922-4.64 5.252 5.252 0 001.736-2.599 5.253 5.253 0 013.551-3.55 5.252 5.252 0 002.599-1.737 5.253 5.253 0 014.64-1.922c1.06.113 2.129-.1 3.065-.61z",
    fill: "#C6F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 15.361,
    stroke: "#B3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.349 21.725l4.59 4.88 8.712-9.21",
    stroke: "#fff",
    strokeWidth: 2
  })));
}
export default SvgBadgeAttorney;